import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { primaryColorDark } from '~theme';

import profileImg from '~images/Paketti-ikonit-profiili.svg';

const propTypes = {
  title: PropTypes.string.isRequired,
};

const Header = ({ title, headerImg, ...rest }) => (
  <HeaderWrapper {...rest}>
    <UserIcon>
      <HeaderImg alt="Profiilikuva" src={headerImg || profileImg} />
    </UserIcon>
    <Username>{title}</Username>
  </HeaderWrapper>
);

const HeaderWrapper = styled.div`
  padding-bottom: 48px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding-bottom: 24px;
  }
`;

const UserIcon = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 100%;
  background-color: ${primaryColorDark};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 76px;
    height: 76px;
  }
`;

const Username = styled.div`
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  margin-top: 24px;
`;

const HeaderImg = styled.img`
  width: 100%;
`;

Header.propTypes = propTypes;

export default Header;
